var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { Formik } from 'formik';
import { sumBy } from 'lodash';
import React, { useState } from 'react';
import * as yup from 'yup';
import { applyBulkActionToMedicationList, createToMedicationList, validateMedicationListName } from '../../Async/MedicationListsAsync';
import { useError } from '../../Components/ErrorBoundary';
import { FullScreenModal } from '../../Components/FullScreenModal';
import { StyledNavigationPrompt } from '../../Components/Prompts/StyledNavigationPrompt';
import { displayMessage } from '../../Config/ApplicationConfig';
import { TimeUnits, useMedicationSettings } from '../../Config/MedicationConfig';
import { ListBulkAction, ListSearchAction } from '../../Contracts/MedicationListModels';
import { requiredField } from '../../Medications.en';
import { defaultAuthoringSystem, selfAuthoringSystemForeignKey } from '../../Shared/Constants';
import { debouncePromise } from '../../Shared/debouncePromise';
import { isDomainValidationError } from '../../Shared/DomainValidationFunctions';
import { MedicationListDefaultOverride } from '../MedicationListSharedSteps/MedicationListDefaultOverride';
import { MedicationListErrors } from '../MedicationListSharedSteps/MedicationListErrors';
import { MedicationListSliceStep } from '../MedicationListSharedSteps/MedicationListSliceStep';
import { createMedicationListStepFields, MedicationListFormErrors_TypeMissing, MedicationListInformationStep } from '../MedicationListSharedSteps/MedicationListInformationStep';
import { CreateMedicationListButtons } from './CreateMedicationListButtons';
import styles from './CreateMedicationListDialog.module.css';
import { CreatingMedicationListPlaceholder } from './CreatingMedicationListPlaceholder';
export var CreateMedicationListStep;
(function (CreateMedicationListStep) {
    CreateMedicationListStep[CreateMedicationListStep["ListInformation"] = 0] = "ListInformation";
    CreateMedicationListStep[CreateMedicationListStep["ListSlices"] = 1] = "ListSlices";
    CreateMedicationListStep[CreateMedicationListStep["DefaultOverride"] = 2] = "DefaultOverride";
    CreateMedicationListStep[CreateMedicationListStep["CreatingMedicationList"] = 3] = "CreatingMedicationList";
    CreateMedicationListStep[CreateMedicationListStep["Error"] = 4] = "Error";
})(CreateMedicationListStep || (CreateMedicationListStep = {}));
function getTitle(step) {
    switch (step) {
        case CreateMedicationListStep.ListInformation:
            return 'Create a medication list';
        case CreateMedicationListStep.ListSlices:
            return 'Add medication to your list';
        case CreateMedicationListStep.DefaultOverride:
            return 'Define your default dosage instructions for your list';
        case CreateMedicationListStep.Error:
            return 'Unable to update medication list';
        case CreateMedicationListStep.CreatingMedicationList:
            return '';
    }
}
function getFormInfo(step) {
    switch (step) {
        case CreateMedicationListStep.ListInformation:
            return 'Provide a meaningful name and select the type of list you want to create.';
        case CreateMedicationListStep.ListSlices:
            return 'Add groups of medications that will share common prescribing characteristics. Select at least one data set to create a valid medication list.';
        case CreateMedicationListStep.DefaultOverride:
            return 'The duration and dosage are used by default for any drug from the collection. You can customise individual drugs later. Use to help manage drug review cycles and streamline prescribing.';
        case CreateMedicationListStep.Error:
            return '';
        case CreateMedicationListStep.CreatingMedicationList:
            return '';
    }
}
function getProgress(step) {
    switch (step) {
        case CreateMedicationListStep.ListInformation:
            return 0;
        case CreateMedicationListStep.ListSlices:
            return 33;
        case CreateMedicationListStep.DefaultOverride:
            return 66;
        case CreateMedicationListStep.CreatingMedicationList:
            return; // Return undefined to hide progress bar.
    }
}
var debouncedValidateMedicationListName = debouncePromise(validateMedicationListName, 250);
var createMedicationListSchema = yup
    .object({
    name: yup
        .string()
        .required(requiredField)
        .test({
        name: 'Name must be unique',
        message: 'Duplicate medication name exists',
        test: function validateName(value) {
            return __awaiter(this, void 0, void 0, function () {
                var result;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!value)
                                return [2 /*return*/, true];
                            return [4 /*yield*/, debouncedValidateMedicationListName(value)];
                        case 1:
                            result = _a.sent();
                            return [2 /*return*/, result.success];
                    }
                });
            });
        }
    }),
    isScopeOfPracticeList: yup.bool().required(requiredField),
    isFormulary: yup.bool().required(requiredField),
    isDefaultList: yup.bool().required(requiredField),
    bulkAction: yup.mixed(),
    atcCodes: yup.array().test({
        name: 'Characteristic required',
        message: 'At least one item required',
        test: function (value) {
            var form = this.parent;
            if (value.length > 0)
                return true;
            return form.schedules.length > 0 || form.medicinalProducts.length > 0;
        }
    }),
    schedules: yup.array().test({
        name: 'Characteristic required',
        message: 'At least one item required',
        test: function (value) {
            var form = this.parent;
            if (value.length > 0)
                return true;
            return form.atcCodes.length > 0 || form.medicinalProducts.length > 0;
        }
    }),
    medicinalProducts: yup.array().test({
        name: 'Characteristic required',
        message: 'At least one item required',
        test: function (value) {
            var form = this.parent;
            if (value.length > 0)
                return true;
            return form.schedules.length > 0 || form.atcCodes.length > 0;
        }
    }),
    defaultDosageInstructions: yup.string().test({
        name: 'Default dosage instructions must exist if overridden is active',
        message: requiredField,
        test: function (value) {
            var form = this.parent;
            if (form.defaultDosageInstructionsOverridden) {
                if (!value)
                    return false;
            }
            return true;
        }
    }),
    defaultDosageInstructionsOverridden: yup.boolean(),
    defaultDuration: yup.object().test({
        name: 'Default duration must have a number if overridden is active',
        message: requiredField,
        test: function (value) {
            var form = this.parent;
            if (form.defaultDurationOverridden) {
                if (!value.number)
                    return false;
            }
            return true;
        }
    }),
    defaultDurationOverridden: yup.boolean(),
    defaultPackAmount: yup.string().test({
        name: 'Default pack amount must have a number if overridden is active',
        message: requiredField,
        test: function (value) {
            var form = this.parent;
            if (form.defaultPackAmountOverridden) {
                if (!value)
                    return false;
            }
            return true;
        }
    }),
    defaultPackAmountOverridden: yup.boolean()
})
    .test({
    name: 'One type of list must be chosen',
    message: 'One type of list must be chosen',
    test: function (value) {
        if (value.isDefaultList)
            return true;
        if (value.isScopeOfPracticeList)
            return true;
        if (value.isFormulary)
            return true;
        return this.createError({
            message: 'Medication list type required.',
            path: MedicationListFormErrors_TypeMissing
        });
    }
});
var MIN_CREATE_DURATION = 2000;
export var CreateMedicationListDialog = function (props) {
    var _a = __read(useState(CreateMedicationListStep.ListInformation), 2), step = _a[0], setStep = _a[1];
    var _b = __read(useState([]), 2), errors = _b[0], setErrors = _b[1];
    var _c = __read(useState(false), 2), medicationListCreated = _c[0], setMedicationListCreated = _c[1];
    var throwError = useError();
    var medicationSettings = useMedicationSettings();
    var handleError = function (errors) {
        setStep(CreateMedicationListStep.Error);
        setErrors(errors);
    };
    var title = getTitle(step);
    var info = getFormInfo(step);
    var progress = getProgress(step);
    var handleClose = function () {
        props.onClose(medicationListCreated);
    };
    var handleBack = function () {
        if (step === CreateMedicationListStep.DefaultOverride)
            setStep(CreateMedicationListStep.ListSlices);
        else if (step === CreateMedicationListStep.ListSlices)
            setStep(CreateMedicationListStep.ListInformation);
    };
    var hideBackButton = step === CreateMedicationListStep.ListInformation || step === CreateMedicationListStep.Error;
    return (React.createElement(FullScreenModal, { title: title, info: info, progressPercent: progress, onBack: handleBack, hideBackButton: hideBackButton, nonInteractivePlaceholder: step === CreateMedicationListStep.CreatingMedicationList ? (React.createElement(CreatingMedicationListPlaceholder, null)) : undefined, onClose: handleClose },
        React.createElement("div", { className: styles.container },
            React.createElement(Formik, { initialValues: {
                    name: '',
                    isScopeOfPracticeList: false,
                    isDefaultList: false,
                    isFormulary: false,
                    bulkAction: ListBulkAction.Append,
                    atcCodes: [],
                    schedules: [],
                    medicinalProducts: [],
                    defaultDuration: {
                        timeUnits: TimeUnits.Days,
                        number: ''
                    },
                    defaultDurationOverridden: false,
                    defaultDosageInstructions: '',
                    defaultDosageInstructionsOverridden: false,
                    defaultPackAmount: '',
                    defaultPackAmountOverridden: false
                }, validationSchema: createMedicationListSchema, onSubmit: function (values, formikActions) { return __awaiter(void 0, void 0, void 0, function () {
                    var timeout, defaults, selectionSlicers, bulkActionPayload, createPayload, result, _a, results, itemsAdded, err_1, errors_1;
                    var _b;
                    return __generator(this, function (_c) {
                        switch (_c.label) {
                            case 0:
                                setStep(CreateMedicationListStep.CreatingMedicationList);
                                timeout = new Promise(function (resolve) { return setTimeout(resolve, MIN_CREATE_DURATION); });
                                defaults = {
                                    defaultDosageInstructions: values.defaultDosageInstructionsOverridden
                                        ? values.defaultDosageInstructions
                                        : '',
                                    defaultDuration: values.defaultDurationOverridden
                                        ? {
                                            timeUnits: values.defaultDuration.timeUnits,
                                            number: Number(values.defaultDuration.number)
                                        }
                                        : null,
                                    defaultPackAmount: values.defaultPackAmountOverridden
                                        ? !!values.defaultPackAmount && !isNaN(Number(values.defaultPackAmount))
                                            ? Number(values.defaultPackAmount)
                                            : null
                                        : null
                                };
                                selectionSlicers = __spreadArray(__spreadArray(__spreadArray([], __read(values.schedules.map(function (it) { return (__assign({ searchCode: it.code, searchAction: ListSearchAction.PoisonSchedule }, defaults)); })), false), __read(values.atcCodes.map(function (it) { return (__assign({ searchCode: it.code, searchAction: ListSearchAction.AtcCode }, defaults)); })), false), __read(values.medicinalProducts.map(function (it) { return (__assign({ searchCode: it.code, searchAction: ListSearchAction.MedicinalProduct }, defaults)); })), false);
                                bulkActionPayload = {
                                    bulkAction: ListBulkAction.Append,
                                    selectionSlicers: selectionSlicers
                                };
                                createPayload = {
                                    authoringSystem: defaultAuthoringSystem,
                                    authoringSystemForeignKey: selfAuthoringSystemForeignKey,
                                    isDefaultList: values.isDefaultList,
                                    isFormulary: values.isFormulary,
                                    isScopeOfPracticeList: values.isScopeOfPracticeList,
                                    name: values.name
                                };
                                _c.label = 1;
                            case 1:
                                _c.trys.push([1, 4, , 5]);
                                return [4 /*yield*/, createToMedicationList(createPayload)];
                            case 2:
                                result = _c.sent();
                                // This makes sure that when the dialog is closed,
                                // if a medication list was created but the bulk action failed, we still refresh the table.
                                setMedicationListCreated(true);
                                return [4 /*yield*/, Promise.all([
                                        applyBulkActionToMedicationList(result.id, bulkActionPayload),
                                        timeout
                                    ])];
                            case 3:
                                _a = __read.apply(void 0, [_c.sent(), 1]), results = _a[0];
                                itemsAdded = sumBy(results.results.filter(function (it) { return it.bulkAction === ListBulkAction.Append; }), function (it) { return it.recordsChanged; });
                                if (itemsAdded)
                                    displayMessage("Medication list created with " + itemsAdded + " items.");
                                else
                                    displayMessage("Medication list created with no items.");
                                formikActions.resetForm({ values: values });
                                props.onComplete(result.id);
                                return [3 /*break*/, 5];
                            case 4:
                                err_1 = _c.sent();
                                // Error handling pattern:
                                // Capture all errors that we want to handle locally.
                                if (isDomainValidationError(err_1)) {
                                    errors_1 = [];
                                    if (err_1.content) {
                                        errors_1 = __spreadArray([], __read(err_1.content), false);
                                    }
                                    else {
                                        errors_1 = [
                                            {
                                                errorMessage: (_b = err_1.message) !== null && _b !== void 0 ? _b : 'Unknown error occurred',
                                                propertyName: ''
                                            }
                                        ];
                                    }
                                    formikActions.resetForm({ values: values });
                                    handleError(errors_1);
                                }
                                else {
                                    // Allow the rest to flow through to the 'throwError' so ErrorBoundary handles them.
                                    throwError(err_1);
                                }
                                return [3 /*break*/, 5];
                            case 5: return [2 /*return*/];
                        }
                    });
                }); } }, function (formProps) {
                var handleContinue = function () { return __awaiter(void 0, void 0, void 0, function () {
                    var errors, noErrors, noErrors;
                    var _a;
                    return __generator(this, function (_b) {
                        switch (_b.label) {
                            case 0: return [4 /*yield*/, formProps.validateForm()];
                            case 1:
                                errors = _b.sent();
                                if (step === CreateMedicationListStep.ListInformation) {
                                    noErrors = Object.keys(errors).filter(function (it) { return createMedicationListStepFields.includes(it); })
                                        .length === 0;
                                    if (noErrors)
                                        setStep(CreateMedicationListStep.ListSlices);
                                    else
                                        formProps.setTouched((_a = {
                                                name: true,
                                                isScopeOfPracticeList: true,
                                                isFormulary: true,
                                                isDefaultList: true
                                            },
                                            _a[MedicationListFormErrors_TypeMissing] = true,
                                            _a));
                                }
                                else if (step === CreateMedicationListStep.ListSlices) {
                                    noErrors = Object.keys(errors).filter(function (it) {
                                        return ['atcCodes', 'schedules', 'medicinalProducts'].includes(it);
                                    }).length === 0;
                                    if (noErrors)
                                        setStep(CreateMedicationListStep.DefaultOverride);
                                    else
                                        formProps.setTouched({
                                            atcCodes: [{ code: true }],
                                            schedules: [{ code: true }],
                                            medicinalProducts: [{ code: true }]
                                        });
                                }
                                else if (step === CreateMedicationListStep.DefaultOverride) {
                                    formProps.submitForm();
                                }
                                return [2 /*return*/];
                        }
                    });
                }); };
                return (React.createElement(React.Fragment, null,
                    step === CreateMedicationListStep.ListInformation && React.createElement(MedicationListInformationStep, { verbalOrderTerm: medicationSettings.settings.verbalOrderTerm }),
                    step === CreateMedicationListStep.ListSlices && (React.createElement(MedicationListSliceStep, { onContinue: handleContinue })),
                    step === CreateMedicationListStep.DefaultOverride && React.createElement(MedicationListDefaultOverride, null),
                    step === CreateMedicationListStep.Error && React.createElement(MedicationListErrors, { errors: errors }),
                    React.createElement(CreateMedicationListButtons, { step: step, formProps: formProps, onClose: handleClose, onContinue: handleContinue }),
                    React.createElement(StyledNavigationPrompt, { when: formProps.isSubmitting || formProps.dirty })));
            }))));
};
